import { AppState } from "../redux/reducers";

export const getUser = (state: AppState) => state.authReducer.user
export const getUserProfile = (state: AppState) => state.userReducer.user
export const getCompany = (state: AppState) => state.companyReducer.company
export const getCompanies = (state: AppState) => state.companyReducer.companies
export const getUnitImagesCount = (state: AppState) => state.unitImagesReducer.unitImagesCount
export const getContractData = (state: AppState) => state.contractsReducer.contract
export const getCountsDisabilityTypes = (state: AppState) => state.a11yesReducer.countsDisabilityTypes
export const getAccessibilityUnitsCounts = (state: AppState) => state.unitsReducer.accessibilityUnitsCounts
export const getTotalAccessibilityProgressBar = (state: AppState) => state.propertyReducer.totalAccessibilityProgressBar
export const getOpenedTheAccessibility = (state: AppState) => state.servicesReducer.mixpanel.openedTheAccessibility
export const getInteractionWithTheAcc = (state: AppState) => state.servicesReducer.mixpanel.interactionWithTheAcc
export const getActionPerVisitor = (state: AppState) => state.servicesReducer.mixpanel.actionPerVisitor
